import React from "react";
import BoomiModal from "components/View/BoomiModal";
import BoomiIcon from "images/G/Boomi.svg";

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export const BOOMI_SOURCE = {
  value: "boomi",
  label: "Boomi",
  image: BoomiIcon,
  settings: [
    { label: "Dataset Name", value: "name", default: "New Dataset" },
    { label: "URL", value: "url" },
    { label: "Account", value: "account" },
    { label: "User", value: "user" },
    { label: "Password", value: "password", isPassword: true },
    { label: "Database", value: "database" },
    { label: "Table", value: "table" },
    { label: "Schema", value: "schema" },
    { label: "Warehouse", value: "warehouse" },
    { label: "Temp Directory (AWS Only)", value: "tempdir" }
  ]
};

export default class DatasetLink extends React.PureComponent {
  constructor(props) {
    super(props);

    const retSettings = {
      type: BOOMI_SOURCE.value
    };

    BOOMI_SOURCE.settings.forEach((setting) => {
      retSettings[setting.value] = setting.default !== undefined ? setting.default : undefined;
    });

    this.state = {
      isLinkModal: BOOMI_SOURCE,
      isMockedTable: false,
      settings: retSettings,
      catalog: {}
    };
  }

  handleHide() {
    const { updateIsLinkMode } = this.props;

    return updateIsLinkMode(false);
  }

  render() {
    const { isLinkMode, handleFileUpload } = this.props;

    return (
      <Dialog open={isLinkMode} onOpenChange={() => this.handleHide()}>
        <DialogContent size="md">
          <DialogHeader>
            <DialogTitle>Create Boomi Connection</DialogTitle>
          </DialogHeader>
          <BoomiModal />
          <div style={{ display: "none" }}>
            <input type="file" ref="file" id="dLink-fUpload" onChange={handleFileUpload} />
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
